var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscDrive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 416H480V96C480 60.625 451.375 32 416 32H96C60.625 32 32 60.625 32 96V416H16C7.125 416 0 423.125 0 432V464C0 472.875 7.125 480 16 480H496C504.875 480 512 472.875 512 464V432C512 423.125 504.875 416 496 416ZM256 416C167.625 416 96 344.375 96 256S167.625 96 256 96S416 167.625 416 256S344.375 416 256 416ZM256 224C238.375 224 224 238.375 224 256S238.375 288 256 288C273.625 288 288 273.625 288 256S273.625 224 256 224Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscDrive);
export default __webpack_public_path__ + "static/media/disc-drive.9f3f521b60162d60ac039e600d9fc381.svg";
export { ForwardRef as ReactComponent };